<template>
	<div>
		<div class="btn-item-div" v-show="parseInt(xgTheme.showRule) == 1"  :style="[{'backgroundColor':bgColor,'color':color}]" @click="showRuleModel=true">
			使用规则
		</div>
		<div class="btn-item-div" v-show="parseInt(xgTheme.showRecord) == 1" :style="[{'backgroundColor':bgColor,'color':color}]" @click="record">
			兑换记录
		</div>
		<div class="btn-item-div" v-show="parseInt(xgTheme.showOperation) == 1" :style="[{'backgroundColor':bgColor,'color':color}]" @click="explain">
			操作流程
		</div>

		<van-popup v-model="showRuleModel" round>
			<div>
				<div class="rule-pop black">
					<div class="t-c w-550 f-s-16">- 使用规则 -</div>
					<div class="f-s-13 p-t-2" v-html="xgTheme.ruleProduct">
						<!-- <div>1.本产品需使用中国移动积分进行兑换。</div>
						<div>2.所兑换的产品仅限在农夫山泉自助贩卖机使用微信支付抵扣使用</div>
						<div>3.兑换说明：下单金额需超过兑换券面值即可抵扣使用，券可叠加，每笔订单最多一次性使用8张券</div>
						<div>4.有效期：为兑换之日七天以内，逾期失效</div>
						<div>5.积分一经兑换成功，不支持退换</div>
						<div>6.客服热线：4000808910（9:00至21:00 每天）</div> -->
					</div>
				</div>
				<div class="close-btn blue" @click="showRuleModel=false">我知道了</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapMutations,
		mapActions
	} from "vuex"
	export default {
		name: 'Option',
		computed: mapGetters(['xgUserInfo','xgTheme']),
		data() {
			return {
				showRuleModel: false,
				getOrderHistoryUrl:'https://cyy.ydong.com.cn/1/order.php'
			}
		},
		props: {
			color: {
				type: String,
				default: '#ffffff'
			},
			bgColor: {
				type: String,
				default: '#626262'
			},
			openId: {
				type: String,
				default: ''
			},
			providerCode: {
				type: String,
				default: ''
			}
		},
		methods: {
			record() {
				let openid = this.openId?this.openId:this.xgUserInfo.openId;
				let providerCode = this.providerCode?this.providerCode:this.xgUserInfo.providerCode
				window.location = this.getOrderHistoryUrl+'?openid=' + openid+'&providerCode='+providerCode
			},
			explain() {
				window.location = this.xgTheme.operationUrl
			}
		},
	}
</script>

<style scoped>
	.btn-item-div {
		margin-bottom: 8px;
		float: right;
		padding: 6px 8px;
		width: max-content;
		height: max-content;
		font-weight: 550;
		font-size: 10px;
		border-top-left-radius: 15px;
		border-bottom-left-radius: 15px;
	}

	.rule-pop {
		width: 90vw;
		padding: 20px;
		text-align: left;
	}


	.close-btn {
		width: 100%;
		font-size: 14px;
		background-color: #f1f1f1;
		text-align: center;
		padding: 15px 0;
	}
</style>
